import { useState, useEffect, useRef } from "react";

export const PREFIX = "Search for a root like ";

// Pairs of (Arabic script, romanization) ordered to teach all non-obvious mappings.
// Each romanization highlights one key mapping so users learn as they watch.
const WORDS = [
  "كتب",  "ktb",   // write           — baseline
  "ثمر",  "thmr",  // fruit           — th → ث
  "حمد",  "Hmd",   // praise          — H  → ح
  "خبر",  "khbr",  // news            — kh → خ
  "ذكر",  "dhkr",  // remember        — dh → ذ
  "شكر",  "shkr",  // gratitude       — sh → ش
  "صبر",  "Sbr",   // patience        — S  → ص
  "ضرب",  "Drb",   // strike          — D  → ض
  "طلب",  "Tlb",   // seek            — T  → ط
  "ظهر",  "Zhr",   // appear          — Z  → ظ
  "فعل",  "fel",   // act             — e  → ع
  "غفر",  "ghfr",  // forgive         — gh → غ
  "قلب",  "qlb",   // heart           — q  → ق
  "سأل",  "s2l",   // ask             — 2  → ء  (hamza)
];
const TYPE_MS  = 110;
const ERASE_MS = 55;
const PAUSE_MS = 1400;

// Returns only the typed part of the example; the caller renders PREFIX separately so it
// can ellipsize the prefix and keep the example visible at large text sizes.
const TypingAnimation = () => {
  const [display, setDisplay] = useState("");
  const state = useRef({ wordIdx: 0, charIdx: 0, phase: "typing" });

  useEffect(() => {
    let timer;

    const tick = () => {
      const s = state.current;
      const word = WORDS[s.wordIdx];

      if (s.phase === "typing") {
        const next = s.charIdx + 1;
        setDisplay(word.slice(0, next));
        if (next >= word.length) {
          s.charIdx = next;
          s.phase = "pausing";
          timer = setTimeout(tick, PAUSE_MS);
        } else {
          s.charIdx = next;
          timer = setTimeout(tick, TYPE_MS);
        }
      } else if (s.phase === "pausing") {
        s.phase = "erasing";
        timer = setTimeout(tick, ERASE_MS);
      } else {
        const next = s.charIdx - 1;
        setDisplay(word.slice(0, next));
        if (next <= 0) {
          s.wordIdx = (s.wordIdx + 1) % WORDS.length;
          s.charIdx = 0;
          s.phase = "typing";
          timer = setTimeout(tick, TYPE_MS + 80);
        } else {
          s.charIdx = next;
          timer = setTimeout(tick, ERASE_MS);
        }
      }
    };

    timer = setTimeout(tick, 600);
    return () => clearTimeout(timer);
  }, []);

  return display;
};

export default TypingAnimation;
